export const bindEvent = (bimRef, { onMouseClick, onMouseRightClick, onTreeNodeClick }) => {
    const viewer = bimRef.current;
    const mouseClicked = Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked;
    const modelTreeNodeClicked = Glodon.Bimface.Application.WebApplication3DEvent.ModelTreeNodeClicked;
    const contextMenu = Glodon.Bimface.Viewer.Viewer3DEvent.ContextMenu;
    viewer?.addEventListener(mouseClicked, (e) => {
        if (onMouseClick) {
            onMouseClick(e, viewer?.getCameraStatus());
        }
    });
    viewer?.addEventListener(modelTreeNodeClicked, (a) => {
        if (onTreeNodeClick) {
            onTreeNodeClick(a);
            // viewer.getModel().getComponentProperty(a.id, (data) => {
            //   console.log('-----', data);
            //   const { boundingBox } = data;
            //   viewer.zoomToBoundingBox(boundingBox);
            //   // createCustomItemContainer();
            //   const config =
            //     new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
            //   const content = document.createElement('div');
            //   content.style.width = '80px';
            //   content.style.height = '32px';
            //   content.style.border = 'solid';
            //   content.style.borderColor = '#FFFFFF';
            //   content.style.borderWidth = '2px';
            //   content.style.borderRadius = '5%';
            //   content.style.background = '#11DAB7';
            //   content.innerText = 'aaa';
            //   content.style.color = '#FFFFFF';
            //   content.style.textAlign = 'center';
            //   content.style.lineHeight = '32px';
            //   config.content = content;
            //   config.viewer = viewer;
            //   config.worldPosition = boundingBox.max;
            //   const customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(
            //     config,
            //   );
            //   customItemContainer.addItem(customItem);
            // });
        }
    });
    viewer?.addEventListener(contextMenu, (e) => {
        if (onMouseRightClick) {
            let a = undefined;
            let b = undefined;
            let c = undefined;
            if (e.objectId) {
                viewer.getComponentProperty([e.objectId], (data) => (a = data));
                viewer.getFloors((data) => (b = data));
                viewer.getNearestAxisGrids(e.worldPosition, '', (data) => (c = data));
                viewer.clearSelectedComponents();
            }
            else {
                viewer.getModelTree((data) => (a = data));
                viewer.getNestedComponents((data) => (b = data));
            }
            onMouseRightClick(a, b, c);
        }
    });
};
